import { Spinner } from "@components/atoms";

interface LoadingPageProps {
  /** Full-height loading page with gradient background */
  withGradient?: boolean;
  /** Show navbar above spinner (for pages with navbar) */
  navbar?: React.ReactNode;
}

/**
 * Full-page loading indicator with spinner.
 * Used for data fetching states across all pages.
 * If withGradient is true, uses the event detail gradient background.
 */
export function LoadingPage({
  withGradient = false,
  navbar,
}: LoadingPageProps) {
  return (
    <div
      className={`flex min-h-screen flex-col ${
        withGradient
          ? "bg-gradient-to-b from-neutral-60 to-primary-110"
          : "bg-neutral-90"
      }`}
    >
      {navbar && navbar}
      <div className="flex flex-1 items-center justify-center">
        <Spinner size={48} className="text-secondary-120" />
      </div>
    </div>
  );
}
